import { Spinner, Strong, Text } from '@radix-ui/themes';
import { CommonDialog } from 'components/common/dialogs';
import { ErrorBoundary } from 'components/common/error-boundary';
import { ActiveUsersCallout } from 'components/sections/admin-portal/machines/dialogs/active-users-callout';
import { useMachinesPortalStore } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import { RestartMode } from 'lib_ts/enums/admin.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useEffect } from 'react';
import { MachinesService } from 'services/machines.service';

const COMPONENT_NAME = 'RestartFirmwareDialog';

interface IProps {
  machineIDs: string[];
  onClose: () => void;
}

export const RestartFirmwareDialog = ({ machineIDs, onClose }: IProps) => {
  const loading = useMachinesPortalStore((s) => s.loading);
  const fetchMachinesAndModels = useMachinesPortalStore(
    (s) => s.fetchMachinesAndModels
  );

  // re-fetch machines when this mounts so we know we have the latest active user status
  useEffect(() => {
    fetchMachinesAndModels();
  }, []);

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      <CommonDialog
        identifier={COMPONENT_NAME}
        title="Restart FW"
        width={RADIX.DIALOG.WIDTH.LG}
        content={
          loading ? (
            <Spinner />
          ) : (
            <Text>
              <p>
                <Strong>
                  Please ensure each machine is not in use before proceeding.
                </Strong>
              </p>
              <p>
                The Arc process on the following machine(s) will be restarted:
              </p>
              <ul>
                {machineIDs.map((machineID) => (
                  <li key={`machine-${machineID}`}>{machineID}</li>
                ))}
              </ul>
              <ActiveUsersCallout machineIDs={machineIDs} />
            </Text>
          )
        }
        buttons={[
          {
            label: 'common.restart',
            color: RADIX.COLOR.SUCCESS,
            variant: 'solid',
            onClick: async () => {
              await MachinesService.getInstance().restart(
                RestartMode.arc,
                machineIDs
              );
              onClose();
            },
            loading,
          },
        ]}
        onClose={onClose}
      />
    </ErrorBoundary>
  );
};
